import { render, staticRenderFns } from "./ApplyGiftCardsModal.vue?vue&type=template&id=0d845272&"
import script from "./ApplyGiftCardsModal.vue?vue&type=script&lang=ts&"
export * from "./ApplyGiftCardsModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports